import React, { useEffect, useState } from 'react';

import _ from 'lodash';

import useRouterHelper from 'hooks/useRouterHelper';
import { useAppSelector } from 'redux/hooks';
import { studySubjectsState } from 'redux/study/studySubjects.slice';
import { IFilterItem } from 'utils/IFilterItem';

import FilterItem from '../FilterItem/FilterItem';
import { IGradesQueryInterface } from '../GradesQueryInterface';

import './FilterBar.scss';

const FilterBar: React.FC = () => {
  const { query, routePush } = useRouterHelper<IGradesQueryInterface>();
  const [groupedSubjects, setGroupedSubjects] = useState({});

  const [classes, setClasses] = useState<Array<IFilterItem>>([]);
  const [subjects, setSubjects] = useState<Array<IFilterItem>>([]);

  const subjectsList = useAppSelector(studySubjectsState);

  const menuItems = [
    {
      title: 'grades:class',
      values: classes,
    },
    {
      title: 'grades:subjects',
      values: subjects,
    },
  ];

  useEffect(() => {
    setGroupedSubjects(_.groupBy(subjectsList.subjects, obj => obj.teaching_structure.parent.id));
  }, [subjectsList]);

  function setSubjectsBasedOnClass() {
    if (!query.Class) {
      return;
    }

    if (query.Class.length === 0) {
      return;
    }

    if (Object.keys(groupedSubjects).length === 0) {
      return;
    }

    const classList = (query.Class as string).split(',');
    if (!query.selectedClassId) {
      routePush({
        search: {
          selectedClassId: classList[0],
        },
      });
    }
    const formattedSubjects = _.uniqBy(
      _.flatten(
        classList.map(obj => {
          return groupedSubjects[obj].map(obj => {
            return {
              title: obj.teaching_structure.title,
              id: obj.subject_id,
            } as IFilterItem;
          });
        })
      ),
      'id'
    );

    setSubjects(formattedSubjects);
    if (!query.Subjects) {
      routePush({
        search: {
          Subjects: formattedSubjects[0].id,
        },
      });
    }
  }

  // format classes
  useEffect(() => {
    setClasses(
      Object.keys(groupedSubjects).map(obj => {
        return {
          id: groupedSubjects[obj][0].teaching_structure.parent.id,
          title: groupedSubjects[obj][0].teaching_structure.parent.title,
        } as IFilterItem;
      }) as Array<IFilterItem>
    );

    setSubjectsBasedOnClass();
  }, [groupedSubjects]);

  // push first class id if none is selected

  useEffect(() => {
    if (query.Class || !classes.length) {
      return;
    }
    routePush({
      search: {
        Class: classes[0].id,
        selectedClassId: classes[0].id,
      },
    });
  }, [classes]);

  // format subjects
  useEffect(() => {
    setSubjectsBasedOnClass();
  }, [query.Class]);

  return (
    <div className="grades-filter-bar">
      {menuItems.map((filterName, i) => (
        <FilterItem key={i} name={filterName.title} values={filterName.values} />
      ))}

      {/* <button className="download">
        <Download fontSize={20} color="rgba(0, 0, 0, 0.5)" />
      </button> */}
    </div>
  );
};

export default FilterBar;
